// src/store/thunks/sixDetail/getInitialDetailThunk.ts
import {
  mapSixActivitiesDTOToSixActivities,
  mapSixFilesApiResponseToFileEntries,
  mapSixSummaryDTOToSixDetailMeta,
  mapParticipantsPayloadDTOToParticipantsResponse,
} from '@/store/mappers/mapSixDetail';
import { initializeP2PStackThunk } from '@/store/thunks/poc/connection/initializeP2PStackThunk';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { syncFilesFromApiThunk } from '@/store/thunks/sixDetail/syncFilesFromApiThunk';
import { withLoader } from '@/store/thunks/thunkWrappers';
import { facilitateFileKeys } from '@/store/thunks/fileKey/facilitateFileKeysThunk';
import { isAPIError } from '@/store/utils';

export const initSixDetailThunk = createAppAsyncThunk(
  'sixDetail/initSixDetail',
  withLoader(
    async(sixIdentifier: string, { dispatch, extra, getState, rejectWithValue }) => {
      try {
        const rootState = getState();
        const activeFilters = rootState.sixDetail.activeFilters;

        const metaDTO = await extra.sixDetailService.getMeta(sixIdentifier, activeFilters);
        const bootstrapNodes = metaDTO.bootstrapNodes
          .map((bootstrapNode) => bootstrapNode.trim())
          .filter((bootstrapNode) => bootstrapNode.length > 0);

        if (bootstrapNodes.length > 0) {
          void dispatch(
            initializeP2PStackThunk({
              sixId: sixIdentifier,
              bootstrapNodes,
            })
          );
        }

        const filesResponse = await extra.sixDetailService.fetchFiles(sixIdentifier, {
          filters: activeFilters,
          path: undefined,
        });
        const activityDTO = await extra.sixDetailService.fetchActivity(sixIdentifier);
        const participantsPayload = await extra.sixDetailService.fetchParticipants(sixIdentifier);

        const meta = mapSixSummaryDTOToSixDetailMeta(metaDTO);
        const participants = mapParticipantsPayloadDTOToParticipantsResponse(participantsPayload);
        const activity = mapSixActivitiesDTOToSixActivities(activityDTO);
        const files = mapSixFilesApiResponseToFileEntries(filesResponse);
        if (typeof filesResponse.totalFileCount === 'number' && meta.fileCount === undefined) {
          meta.fileCount = filesResponse.totalFileCount;
        }

        void dispatch(syncFilesFromApiThunk({ sixId: sixIdentifier, files }));
        void dispatch(facilitateFileKeys());
        return {
          sixId: sixIdentifier,
          meta,
          files,
          activity,
          participants,
        };
      } catch (error) {
        if (isAPIError(error)) {
          return rejectWithValue({ message: error.message, status: error.status });
        }
        throw error;
      }
    },
  ),
);
